import { create } from 'zustand';

interface RfqFailedBannerStore {
  // A failed RFQ banner exists but has been dismissed — the header shows a
  // "N processing issues" badge that opens the file-details dialog. Written by
  // the banner (which owns the failed/dismissed inputs), read by the badge.
  hasDismissedFailure: boolean;
  setHasDismissedFailure: (hasDismissedFailure: boolean) => void;
  reset: () => void;
}

export const useRfqFailedBannerStore = create<RfqFailedBannerStore>(set => ({
  hasDismissedFailure: false,
  setHasDismissedFailure: hasDismissedFailure => set({ hasDismissedFailure }),
  reset: () => set({ hasDismissedFailure: false })
}));
